import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-jss';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { Router } from '@bingads-webui-campaign-react/router';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { UserContext } from '@bingads-webui-react/user-context';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { BroadOnlySetting } from './index';

// wrap the required context here for legacy scenarios
export const WrappedBroadOnlySetting = ({
  theme,
  i18n,
  preferenceService,
  scope,
  serverContext,
  permissions,
  ...props
}) => {
  if (!theme || !i18n || !preferenceService) {
    return null;
  }
  const userContext = {
    CurrentUser: serverContext.CurrentUser,
    CurrentCustomer: serverContext.CurrentCustomer,
    CurrentAccount: serverContext.CurrentAccount,
  };
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <I18nContext.Provider value={i18n}>
          <ScopeContext.Provider value={{ scope }}>
            <UserContext.Provider value={userContext}>
              <PermissionsContext.Provider value={permissions} >
                <PreferenceContext.Provider value={preferenceService}>
                  <BroadOnlySetting {...props} />
                </PreferenceContext.Provider>
              </PermissionsContext.Provider>
            </UserContext.Provider>
          </ScopeContext.Provider>
        </I18nContext.Provider>
      </ThemeProvider>
    </Router>
  );
};

WrappedBroadOnlySetting.propTypes = {
  theme: PropTypes.shape({
    components: PropTypes.shape({}),
    core: PropTypes.shape({}),
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  preferenceService: PropTypes.shape({
    findByNameAtAccountLevel: PropTypes.func,
    setAtAccountLevel: PropTypes.func,
  }).isRequired,
  scope: PropTypes.shape({}).isRequired,
  serverContext: PropTypes.shape({
    CurrentUser: PropTypes.shape({}),
    CurrentCustomer: PropTypes.shape({}),
    CurrentAccount: PropTypes.shape({}),
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};
